@if (!item().clCompChat_hidden) {
  <div
    class="chat-item"
    #chatItem
    [attr.tabindex]="previewMode ? '-1' : currentTabIndex()"
    (focus)="onFocus($event)"
    (click)="messageSelected()"
    (keydown.enter)="messageSelected()"
    [ngClass]="{
      'continue-item': isContinuation() && !isSearch() && (!selectMessagesMode || !isMine()),
      'start-item': !isContinuation() || isSearch(),
      'chat-item-preview-mode': previewMode,
      'chat-item-selectMessagesMode': selectMessagesMode && isMine()
    }"
    (mouseenter)="onMouseEnter($event)"
    (mouseleave)="onMouseLeave($event)"
    [ngStyle]="{
      'border-color': primeThemeService.isDarkMode() && previewMode ? 'transparent' : 'var(--p-surface-100)'
    }"
  >
    @if (selectMessagesMode && isMine() && !isSystemMessage() && !isErrorMessage()) {
      <div
        class="selectMessagesMode"
        [ngClass]="{
          'continue-item-selectMessagesMode': isContinuation()
        }"
      >
        @if (!isMessageSelected) {
          <div class="w-6 h-6 flex items-center justify-center">
            <div class="w-6 h-6 rounded-full border-2 border-surface-400 bg-transparent"></div>
          </div>
        }

        @if (isMessageSelected) {
          <div class="w-6 h-6 flex items-center justify-center rounded-full bg-primary">
            <i class="mi2-check text-lg text-surface-0"></i>
          </div>
        }
      </div>
    }

    @if (
      !previewMode && showMessageOptions() && showOptionsArea() && !showEditMode() && !smsMode() && !selectMessagesMode
    ) {
      <div
        #messageOptions
        class="message-options"
        [ngClass]="{
          'text-area-disabled': textAreaDisabled(),
          'message-options-visible': showReactionsArea() || showMoreOptions()
        }"
        [ngStyle]="{
          'box-shadow': 'var(--p-mi-shadow)',
          'border-color': primeThemeService.isDarkMode() ? 'var(--p-surface-0)' : 'var(--p-surface-950)'
        }"
      >
        <!-- Ugly, but for some reason in MOWA, new message tooltips aren't triggering zone :(, need to handle showing them using the technique below -->
        @if (!config()?.hideMessageOptionsReaction) {
          <div class="message-emoji-option">
            <button
              class="message-option-emoji button-remove-style"
              [attr.aria-label]="'cl_chat.reactionOptions.thumbsUp' | translate"
              tabindex="0"
              [ngClass]="{ 'setting-reaction': settingReaction()['👍'] }"
              (click)="setReaction('👍')"
              (keydown.enter)="setReaction('👍')"
              data-e2e="emoji-thumbs-up"
              [innerHtml]="isMobile || !config()?.enableTwemoji ? '👍' : ('1F44D' | emoji)"
            ></button>
            <button
              class="message-option-emoji button-remove-style"
              [attr.aria-label]="'cl_chat.reactionOptions.thumbsDown' | translate"
              tabindex="0"
              [ngClass]="{ 'setting-reaction': settingReaction()['👎'] }"
              (click)="setReaction('👎')"
              (keydown.enter)="setReaction('👎')"
              [innerHtml]="isMobile || !config()?.enableTwemoji ? '👎' : ('1F44E' | emoji)"
            ></button>
            <button
              class="message-option-emoji button-remove-style"
              [attr.aria-label]="'cl_chat.reactionOptions.happy' | translate"
              tabindex="0"
              [ngClass]="{ 'setting-reaction': settingReaction()['😄'] }"
              (click)="setReaction('😄')"
              (keydown.enter)="setReaction('😄')"
              [innerHtml]="isMobile || !config()?.enableTwemoji ? '😄' : ('1F604' | emoji)"
            ></button>
            <button
              class="message-option-emoji button-remove-style"
              [attr.aria-label]="'cl_chat.reactionOptions.love' | translate"
              tabindex="0"
              [ngClass]="{ 'setting-reaction': settingReaction()['😍'] }"
              (click)="setReaction('😍')"
              (keydown.enter)="setReaction('😍')"
              [innerHtml]="isMobile || !config()?.enableTwemoji ? '😍' : ('1F60D' | emoji)"
            ></button>
            <button
              class="message-option-emoji button-remove-style"
              [attr.aria-label]="'cl_chat.reactionOptions.sad' | translate"
              tabindex="0"
              [ngClass]="{ 'setting-reaction': settingReaction()['😩'] }"
              (click)="setReaction('😩')"
              (keydown.enter)="setReaction('😩')"
              [innerHtml]="isMobile || !config()?.enableTwemoji ? '😩' : ('1F629' | emoji)"
            ></button>
            <button
              class="message-option-emoji button-remove-style"
              [attr.aria-label]="'cl_chat.reactionOptions.question' | translate"
              tabindex="0"
              [ngClass]="{ 'setting-reaction': settingReaction()['🤨'] }"
              (click)="setReaction('🤨')"
              (keydown.enter)="setReaction('🤨')"
              [innerHtml]="isMobile || !config()?.enableTwemoji ? '🤨' : ('1F928' | emoji)"
            ></button>
          </div>
          <div class="ml-[3px] mr-[6px] border-r border-solid border-surface-950 dark:border-surface-0 h-full"></div>
        }
        @if (hasTranslation()) {
          <button
            class="message-options-button button-remove-style"
            [ngClass]="{ translated: isTranslated() }"
            [attr.aria-label]="'cl_chat.translate' | translate"
            id="message-options-translate"
            [pTooltip]="'cl_chat.translate' | translate"
            tooltipPosition="top"
            tabindex="0"
            (keydown.enter)="flipTranslation()"
            (click)="flipTranslation()"
          >
            <i class="mi2-translate text-lg"></i>
          </button>
        }
        @if (showPdfMessageOptions()) {
          <button
            class="message-options-button button-remove-style"
            [attr.aria-label]="'cl_chat.preview' | translate"
            id="message-options-preview-pdf"
            [pTooltip]="'cl_chat.preview' | translate"
            tooltipPosition="top"
            tabindex="0"
            (click)="fullScreenPdf()"
          >
            <i class="mi2-visibility-on text-lg"></i>
          </button>
        }
        <!-- Temporary for audio until we have a proper mobile design for audio cards -->
        @if (showDownloadMessageOptions()) {
          <button
            class="message-options-button button-remove-style"
            [attr.aria-label]="'cl_chat.download' | translate"
            id="message-options-download"
            [pTooltip]="'cl_chat.download' | translate"
            tooltipPosition="top"
            tabindex="0"
            (keydown.enter)="!isOffline() ? downloadAttachment(item().clCompChat_displayBody) : ''"
            (click)="!isOffline() ? downloadAttachment(item().clCompChat_displayBody) : ''"
          >
            <i
              [ngClass]="{ 'cl-chat-button-disabled': isOffline() }"
              class="mi2-download text-lg text-surface-950 dark:text-surface-0"
            ></i>
          </button>
        }
        @if (!config()?.hideMessageOptionsReply && !item()?.messageId.startsWith('local')) {
          <button
            class="message-options-button button-remove-style"
            [attr.aria-label]="'cl_chat.reply' | translate"
            id="message-options-quote"
            [pTooltip]="'cl_chat.reply' | translate"
            tooltipPosition="top"
            tabindex="0"
            (keydown.enter)="!textAreaDisabled() ? quoteMessageClick($event) : ''"
            (click)="!textAreaDisabled() ? quoteMessageClick($event) : ''"
          >
            <i
              [ngClass]="{ 'cl-chat-button-disabled': textAreaDisabled() }"
              class="mi2-reply text-lg text-surface-950 dark:text-surface-0"
            ></i>
          </button>
        }
        @if (config()?.showGoToAiSuggestions) {
          <button
            class="message-options-button button-remove-style"
            [attr.aria-label]="'cl_chat.suggestions' | translate"
            id="ai-suggestions"
            tabindex="0"
            (keydown.enter)="goToAiSuggestions()"
            (click)="goToAiSuggestions()"
          >
            <i class="mi2-file-text text-lg text-surface-950 dark:text-surface-0"></i>
          </button>
        }
        @if (showMoreMessageOptions() && !(participants().length === 2 && !isMine())) {
          <button
            class="message-options-button button-remove-style"
            [attr.aria-label]="'cl_chat.more' | translate"
            id="message-options-more"
            [pTooltip]="'cl_chat.more' | translate"
            tooltipPosition="top"
            tabindex="0"
            (click)="!textAreaDisabled() ? showMoreDropDown($event) : ''"
          >
            <i
              [ngClass]="{ 'cl-chat-button-disabled': textAreaDisabled() }"
              class="mi2-more-vertical text-lg text-surface-950 dark:text-surface-0"
            ></i>
          </button>
        }
      </div>
    }
    @if (showOptionsArea() && showMoreOptions() && !textAreaDisabled()) {
      <div
        #moreOptions
        class="more-options"
        [ngStyle]="{
          right: moreOptionsRight,
          top: moreOptionsTop,
          'box-shadow': 'var(--p-mi-shadow)',
          'border-color': primeThemeService.isDarkMode() ? 'var(--p-surface-0)' : 'var(--p-surface-950)'
        }"
      >
        @if ((isTextContentType() || isQuotedContentType()) && config()?.showMessageOptionsEdit && isMine()) {
          <div
            role="button"
            [attr.aria-label]="'cl_chat.editMessage' | translate"
            class="more-options-edit"
            (keydown.enter)="editMessage($event)"
            (keydown.space)="$event.preventDefault(); editMessage($event)"
            tabindex="0"
            (click)="editMessage($event)"
          >
            <span>{{ 'cl_chat.editMessage' | translate }}</span>
          </div>
        }
        @if (
          config()?.showMessageOptionsSelect &&
          config()?.showMessageOptionsDelete &&
          isDelivered() &&
          isMine() &&
          !isRecording()
        ) {
          <div
            role="button"
            [attr.aria-label]="'cl_chat.selectMessages' | translate"
            class="more-options-select"
            (keydown.enter)="selectMessages()"
            (keydown.space)="$event.preventDefault(); selectMessages()"
            tabindex="0"
            (click)="selectMessages()"
          >
            <span>{{ 'cl_chat.selectMessages' | translate }}</span>
          </div>
        }
        @if (!config()?.hideMessageOptionsInfo && participants()?.length > 1 && isDelivered()) {
          <div
            role="button"
            [attr.aria-label]="'cl_chat.messageInfo' | translate"
            class="more-options-info"
            (keydown.enter)="messageInfo($event)"
            (keydown.space)="$event.preventDefault(); messageInfo($event)"
            tabindex="0"
            (click)="messageInfo($event)"
          >
            <span>{{ 'cl_chat.messageInfo' | translate }}</span>
          </div>
        }
        @if (config()?.showMessageOptionsDelete && isMine()) {
          <div
            role="button"
            [attr.aria-label]="'cl_chat.deleteMessage' | translate"
            class="more-options-delete"
            tabindex="0"
            (keydown.enter)="openDeleteMessageDialog()"
            (keydown.space)="$event.preventDefault(); openDeleteMessageDialog()"
            (click)="openDeleteMessageDialog()"
          >
            <span>{{ 'cl_chat.deleteMessage' | translate }}</span>
          </div>
        }
      </div>
    }
    @if (!isCustomElement && (!isContinuation() || isSearch()) && !isSystemMessage() && !smsMessage()) {
      <mi-avatar
        [hash]="item().createdBy | hash"
        [name]="getDisplayName(item().createdBy, true)"
        [initials]="getDisplayName(item().createdBy, true) | initials"
        [photoUrl]="
          chatAdminService.avatars[item().createdBy]?.hasOwnProperty('150')
            ? chatAdminService.avatars[item().createdBy][150]
            : ''
        "
        [attr.aria-label]="'cl_chat.profilePhoto' | translate"
        role="img"
        tabindex="0"
      >
      </mi-avatar>
    }
    @if (isCustomElement && (!isContinuation() || isSearch()) && !isSystemMessage() && !smsMessage()) {
      <mi-avatar
        [hash]="item().createdBy | hash"
        [name]="getDisplayName(item().createdBy, true)"
        [initials]="getDisplayName(item().createdBy, true) | initials"
        [photoUrl]="imageSource(item())"
        [attr.aria-label]="'cl_chat.profilePhoto' | translate"
        role="img"
        tabindex="0"
      >
      </mi-avatar>
    }

    @if (smsMessage() && (!isContinuation() || isSearch())) {
      <mi-avatar
        [photoUrl]="'assets/images/cl-chat/sms.svg' | chatAssetUrl"
        [attr.aria-label]="'cl_chat.profilePhoto' | translate"
      >
      </mi-avatar>
    }
    @if (isSystemMessage() && (!isContinuation() || isSearch())) {
      @if (customAvatarSrc()) {
        <img class="custom-avatar" [src]="customAvatarSrc()" alt="" />
      } @else {
        <mi-avatar
          [photoUrl]="'assets/images/cl-chat/system-avatar.svg' | chatAssetUrl"
          [attr.aria-label]="'cl_chat.profilePhoto' | translate"
        >
        </mi-avatar>
      }
    }
    @if (isContinuation() && !isSearch() && !isSystemMessage() && !selectMessagesMode) {
      <div
        class="date-hover"
        [pTooltip]="item().createdOn | chatDate: dateTimeLocale() : config()?.showDayOfWeek"
        tooltipPosition="top"
        container="body"
      >
        {{ item().createdOn | date: 'shortTime' : undefined : dateTimeLocale() }}
      </div>
    }
    <div #messageContent class="item-content" data-e2e="item-content">
      @if (!isContinuation() || isSearch()) {
        <div class="name">
          <span>
            @if (!isSystemMessage()) {
              <span
                data-e2e="username"
                role="button"
                tabindex="0"
                [ngClass]="{ pointer: config()?.showNamePointer && !smsMessage() }"
                (click)="nameClicked(item().createdBy)"
                (keydown.enter)="nameClicked(item().createdBy)"
                (keydown.space)="$event.preventDefault(); nameClicked(item().createdBy)"
                >{{ getDisplayName(item().createdBy) }}</span
              >
            } @else {
              <span data-e2e="system-message">{{ 'cl_chat.system' | translate }}</span>
            }
            <span
              class="date"
              data-e2e="date"
              [pTooltip]="item().createdOn | chatDate: dateTimeLocale() : config()?.showDayOfWeek"
              tooltipPosition="top"
              container="body"
            >
              {{ item().createdOn | date: 'shortTime' : undefined : dateTimeLocale() }}
            </span>
            @if (isSearch()) {
              <div
                class="go-to-message"
                role="button"
                tabindex="0"
                (click)="goToMessage()"
                (keydown.enter)="goToMessage()"
                (keydown.space)="$event.preventDefault(); goToMessage()"
              >
                <span>{{ 'cl_chat.goToMessage' | translate }}</span>
              </div>
            }
          </span>
        </div>
      }

      <!-- START MAIN CONTENT -->
      <div
        [ngSwitch]="contentType()"
        [ngClass]="{
          'start-content': !isContinuation(),
          'whisper-content': isWhisper()
        }"
        [attr.data-e2e]="isWhisper() ? 'whisper-content' : null"
      >
        @if (isWhisper()) {
          <div
            class="whisper-emoji"
            [innerHTML]="isMobile || !config()?.enableTwemoji ? '🤫' : ('1F92B' | emoji)"
          ></div>
        }
        @if (contentType() === contentTypes.QUOTED) {
          <app-quoted-message-card
            [quoteMessage]="quoteMessage()"
            [dateTimeLocale]="dateTimeLocale()"
            (loadQuotedMessage)="goToQuotedMessage()"
            [previewMode]="previewMode"
          >
          </app-quoted-message-card>
        }
        <div class="chat-container">
          @if (!showEditMode()) {
            <div
              class="chat-message bg-surface-100 dark:bg-surface-600"
              #chatMessage
              (contextmenu)="messageContextMenu($event)"
              [ngClass]="{
                'empty-quoted-message': contentType() === contentTypes.QUOTED && !quoteMessage().content.body,
                'my-content': isMine(),
                'system-message': isSystemMessage() || clickToLoadImage(),
                'error-message': isErrorMessage(),
                'location-message': contentType() === contentTypes.LOCATION && !isErrorMessage(),
                'media-message': isMediaMessage() && !clickToLoadImage(),
                'large-image': clickToLoadImage(),
                'video-message': isVideoMessage() && !isVideoMessageWithContent(),
                'whisper-error': isWhisperError(),
                'no-padding': isNoPadding() && !isErrorMessage(),
                'action-message': contentType() === contentTypes.ACTIONCARD,
                'ms-adaptive-card': contentType() === contentTypes.MSADAPTIVECARD,
                'attachment-image-message': isAttachmentImage(),
                'attachment-message':
                  ((contentType() === contentTypes.ATTACHMENT ||
                    contentType() === contentTypes.ATTACHMENTSYSTEMMESSAGE) &&
                    simpleType() != 'audio') ||
                  contentType() === contentTypes.CLOUDFILELINK,
                'audio-message': simpleType() === 'audio' || contentType() === contentTypes.VOICEMAIL,
                'attachment-file':
                  simpleType() != 'image' &&
                  simpleType() != 'video' &&
                  contentType() != contentTypes.LOCATION &&
                  !isSystemMessage(),
                'loading-image': imageLoading(),
                'previewMode': previewMode
              }"
              [ngStyle]="{ 'max-width': getChatMessageMaxWidth() }"
              [attr.data-e2e]="
                contentType() === contentTypes.LOCATION && !isErrorMessage() ? 'location-message' : 'chat-message'
              "
            >
              <ng-template [ngSwitchCase]="contentTypes.LOCATION">
                <app-location-card
                  [showLocation]="showLocation()"
                  (showLocationChange)="showLocation.set($event)"
                  [isOfflineCache]="isOfflineCache"
                  [chatMessage]="chatMessage"
                  [latitude]="latitude()"
                  [longitude]="longitude()"
                  [isMine]="isMine()"
                >
                </app-location-card>
              </ng-template>
              <ng-template [ngSwitchCase]="contentTypes.QUOTED">
                <div
                  class="content"
                  [ngClass]="{ 'my-content': isMine() }"
                  [ngSwitch]="quoteMessage()?.content?.contentType"
                >
                  <span
                    #quotecontent
                    *ngSwitchCase="contentTypes.HTML"
                    [innerHTML]="quoteMessage().content.body | linky"
                  ></span>
                  <span
                    #quotecontent
                    *ngSwitchCase="contentTypes.TEXT"
                    [innerHTML]="quoteMessage().content.body | linky"
                  ></span>
                  <span #quotecontent *ngSwitchDefault>{{ quoteMessage().content.body }}</span>
                  @if (isEdited()) {
                    <span
                      class="edited-content"
                      placement="top"
                      [pTooltip]="item().modifiedOn | unreadMessageDate: dateTimeLocale()"
                      tooltipPosition="top"
                      [ngClass]="{ 'my-content': isMine() }"
                      >({{ 'cl_chat.edited' | translate | titlecase }})</span
                    >
                  }
                </div>
                @if (isUpdatingMessage()) {
                  <div class="flex items-center gap-2 mt-2">
                    <p-progress-spinner
                      styleClass="w-5 h-5"
                      strokeWidth="8"
                      animationDuration=".5s"
                      fill="transparent"
                      [attr.aria-label]="'cl_chat.updating' | translate"
                    >
                    </p-progress-spinner>
                    <span class="text-sm text-surface-0">{{ 'cl_chat.updating' | translate }}</span>
                  </div>
                }
              </ng-template>
              <ng-template
                [ngSwitchCase]="
                  contentType() === contentTypes.ATTACHMENT || contentType() === contentTypes.ATTACHMENTSYSTEMMESSAGE
                    ? contentType()
                    : 'ignore'
                "
              >
                <app-attachment-card
                  [ngStyle]="{
                    'max-width': imageWidth() && imageWidth() < 600 ? imageWidth() / 14 + 'rem' : ''
                  }"
                  [isOfflineCache]="isOfflineCache"
                  [item]="item()"
                  [attachmentName]="attachmentName()"
                  [attachmentSize]="attachmentSize()"
                  [clickToLoadImage]="clickToLoadImage()"
                  [isMine]="isMine()"
                  [imageViewerUrl]="imageViewerUrl()"
                  [currentTabIndex]="currentTabIndex()"
                  [blobUrl]="blobUrl()"
                  [isOffline]="isOffline()"
                  [isMobile]="isMobile"
                  [simpleType]="simpleType()"
                  [chatItemElement]="chatItem"
                  [(contentType)]="contentType"
                  [isErrorMessage]="isErrorMessage()"
                  (isErrorMessageChange)="isErrorMessage.set($event)"
                  [previewMode]="previewMode"
                  (onFullScreenImage)="fullScreenImage()"
                  (onDownloadAttachment)="downloadAttachment($event)"
                  (onLoadImageAttachment)="loadImageAttachment()"
                  (onCloseOptions)="closeOptions($event)"
                >
                </app-attachment-card>
              </ng-template>
              <ng-template [ngSwitchCase]="contentTypes.WHISPER">
                <span
                  class="content"
                  [ngClass]="{ 'my-content': isMine() }"
                  [innerHTML]="item().clCompChat_displayBody | linky"
                ></span>
              </ng-template>
              <ng-template [ngSwitchCase]="contentTypes.HTML">
                <!-- Inline image viewing -->
                @if (useImageViewer()) {
                  <div #linkImage class="image-message" [ngClass]="{ 'item-preview-mode': previewMode }">
                    @if (imageViewerUrl()) {
                      <img
                        [attr.tabindex]="currentTabIndex()"
                        (keydown.enter)="fullScreenImage()"
                        (click)="fullScreenImage()"
                        [src]="imageViewerUrl()"
                        [ngClass]="{
                          'image-before-content': isImageMessageWithContent() || isHtmlMessage()
                        }"
                        alt=""
                      />
                    }
                  </div>
                }
                <!-- Normal html-->
                @if (useImageViewer() === false && itemContent()) {
                  <span
                    #multimediaMessage
                    [ngStyle]="
                      isVideoMessage() &&
                      itemContent() && {
                        'height.rem': multimediaMessage.offsetWidth / mediaHeightRatio() / 16
                      }
                    "
                    [innerHTML]="itemContent() | linky"
                    class="content"
                    [ngClass]="{
                      'video-player-message': isVideoMessage() && itemContent(),
                      'video-before-content': isVideoMessageWithContent(),
                      'my-content': isMine()
                    }"
                  ></span>
                }
                @if (isVideoMessageWithContent() || isImageMessageWithContent() || isHtmlMessage()) {
                  <span
                    #htmlMessage
                    class="content"
                    [ngClass]="{ 'my-content': isMine(), 'media-text': isMediaMessage() }"
                    [innerHTML]="item().clCompChat_displayBody | linky"
                    [attr.data-e2e]="isMediaMessage() ? 'media-text' : null"
                  ></span>
                }
              </ng-template>
              <ng-template [ngSwitchCase]="contentTypes.TEXT">
                <span
                  #textSpan
                  class="content text-content"
                  [ngClass]="{ 'my-content': isMine() }"
                  [innerHTML]="
                    isUpdatingMessage()
                      ? (previewEditMessageContent() | linky)
                      : (item().clCompChat_displayBody | linky)
                  "
                ></span>
                @if (isEdited()) {
                  <span
                    class="edited-content"
                    placement="top"
                    [pTooltip]="item().modifiedOn | unreadMessageDate: dateTimeLocale()"
                    tooltipPosition="top"
                    [ngClass]="{ 'my-content': isMine() }"
                    >({{ 'cl_chat.edited' | translate | titlecase }})</span
                  >
                }
                @if (isUpdatingMessage()) {
                  <div class="flex items-center gap-2 mt-2">
                    <p-progress-spinner
                      styleClass="w-5 h-5"
                      strokeWidth="8"
                      animationDuration=".5s"
                      fill="transparent"
                      [attr.aria-label]="'cl_chat.updating' | translate"
                    >
                    </p-progress-spinner>
                    <span class="text-sm text-surface-0">{{ 'cl_chat.updating' | translate }}</span>
                  </div>
                }
              </ng-template>
              <ng-template [ngSwitchCase]="contentTypes.MARKDOWN">
                @if (item().clCompChat_toolCalls?.length) {
                  <app-ai-thinking-card
                    [toolCalls]="item().clCompChat_toolCalls!"
                    [hasAnswerText]="!!item().clCompChat_displayBody"
                    [streaming]="!!item().clCompChat_aiStreaming"
                  ></app-ai-thinking-card>
                }
                <div
                  #markdownContent
                  class="content markdown-content"
                  [ngClass]="{
                    'my-content': isMine(),
                    'ai-streaming': item().clCompChat_aiStreaming
                  }"
                  [innerHTML]="item().clCompChat_displayBody | markdown"
                  (click)="onCodeBlockClick($event)"
                ></div>
                @if (item().clCompChat_sources?.length) {
                  <app-ai-sources-card [sources]="item().clCompChat_sources!"></app-ai-sources-card>
                }
                @if (item().clCompChat_stats) {
                  <app-ai-stats-row [stats]="item().clCompChat_stats!"></app-ai-stats-row>
                }
                @if (showAiQuickReplies()) {
                  <app-ai-quick-replies
                    [options]="item().clCompChat_quickReplies ?? []"
                    [handoffLabel]="aiHandoffLabel()"
                    [disabled]="aiQuickRepliesDisabled()"
                    (selected)="onAiQuickReply.emit($event)"
                    (handoff)="onAiHandoff.emit()"
                  ></app-ai-quick-replies>
                }
              </ng-template>
              <!-- TODO Handle offline viewing -->
              <ng-template [ngSwitchCase]="contentTypes.MISSEDCALL">
                <app-call-card
                  [bodyObject]="bodyObject()"
                  [dateTimeLocale]="dateTimeLocale()"
                  (onLaunchDialer)="launchActionCardDialer($event)"
                  [currentTabIndex]="currentTabIndex()"
                >
                </app-call-card>
              </ng-template>
              <!-- TODO Handle offline viewing -->
              <ng-template [ngSwitchCase]="contentTypes.VOICEMAIL">
                <app-audio-card
                  [isVoicemail]="true"
                  [item]="item()"
                  [currentTabIndex]="currentTabIndex()"
                  [attachmentName]="attachmentName()"
                  [attachmentSize]="attachmentSize()"
                  [blobUrl]="blobUrl()"
                  [isOffline]="isOffline()"
                  [isMobile]="isMobile"
                  [attr.aria-label]="'cl_chat.fileLabels.audio' | translate: { fileName: attachmentName() }"
                  [previewMode]="previewMode"
                  (onDownloadAttachmentClicked)="downloadAttachment($event)"
                >
                </app-audio-card>
              </ng-template>
              <!-- Start of message templates -->
              <ng-template [ngSwitchCase]="contentTypes.ACTIONCARD">
                <span></span>
                <!-- BEGIN Debug tag - COMMENT OUT
                  <pre>{{item.clCompChat_displayBody}}</pre>-->
                <!-- END Debug tag only -->
                <app-action-card
                  [bodyObject]="bodyObject()"
                  [contentType]="contentType()"
                  [currentTabIndex]="currentTabIndex()"
                  [imageViewerUrl]="imageViewerUrl()"
                  [item]="item()"
                  [isOffline]="isOffline()"
                  [latitude]="latitude()"
                  [longitude]="longitude()"
                  (onLaunchDialer)="launchActionCardDialer($event)"
                  (onActionCardBehavior)="onActionCardBehavior($event)"
                  (onOpenLink)="onOpenLink($event)"
                  (onPostWebhookPayload)="onPostWebhookPayload($event)"
                  (onActionCardEvent)="onActionCardEvent($event)"
                  (onSendActionCardMessage)="onSendActionCardMessage($event)"
                  (onQuotedMessageChange)="onQuotedMessageChange.emit($event)"
                  (onGetCurrentLocation)="onGetCurrentLocation.emit($event)"
                  [(actionCardMaxWidth)]="actionCardMaxWidth"
                  [goingToQuoted]="goingToQuoted()"
                  [actionCardImageNearBottom]="actionCardImageNearBottom()"
                  [actionCardScrolledToMessage]="actionCardScrolledToMessage()"
                  [previewMode]="previewMode"
                >
                </app-action-card>
              </ng-template>
              <ng-template [ngSwitchCase]="contentTypes.SYSTEMMESSAGE">
                <app-system-message-card [systemMessage]="item().clCompChat_displayBody"> </app-system-message-card>
              </ng-template>
              <ng-template [ngSwitchCase]="contentTypes.MSADAPTIVECARD">
                <adaptive-card-renderer
                  [item]="item()"
                  [previewMode]="previewMode"
                  (onSendWebhookPayload)="onSendWebhookPayload($event)"
                  (onOpenLink)="onOpenLink($event)"
                ></adaptive-card-renderer>
              </ng-template>
              <ng-template [ngSwitchCase]="contentTypes.CLOUDFILELINK">
                <app-cloud-file-card
                  [item]="item()"
                  [isMine]="isMine()"
                  [currentTabIndex]="currentTabIndex()"
                  [previewMode]="previewMode"
                ></app-cloud-file-card>
              </ng-template>
              <ng-template [ngSwitchCase]="contentTypes.ERROR">
                <div class="content">
                  <i class="mi2-error text-[18px] text-surface-0 bg-red-500 p-1 rounded-full"></i>
                  <span class="failed">{{ 'cl_chat.errorLoadingMessage' | translate }}</span>
                </div>
              </ng-template>
              <!-- Ensure we handle types we don't understand-->
              <ng-template ngSwitchDefault>
                @if (!fallbackText()) {
                  <div
                    class="content"
                    [ngClass]="{ 'my-content': isMine() }"
                    translate
                    [translateParams]="{ type: contentType() }"
                  >
                    cl_chat.unableToDisplayContent
                  </div>
                }
                @if (fallbackText()) {
                  <div class="content" [ngClass]="{ 'my-content': isMine() }">
                    {{ fallbackText() }}
                  </div>
                }
              </ng-template>
            </div>
          }

          @if (
            isMine() &&
            !showEditMode() &&
            ((contentType() === contentTypes.QUOTED && quoteMessage().content.body) ||
              contentType() !== contentTypes.QUOTED)
          ) {
            <div class="flex justify-end items-center">
              <!-- check mark delivered indicator -->
              @if (isDelivered()) {
                <div
                  class="inline-flex flex-row items-center justify-center bg-surface-600 dark:bg-surface-100 rounded-full w-5 h-5 border border-solid border-surface-0 dark:border-surface-950 [animation:checkmarksAnimation_1s_1] ml-2"
                  [pTooltip]="'cl_chat.delivered' | translate"
                  tooltipPosition="left"
                  container="body"
                >
                  <i class="mi2-check text-[8px] text-surface-0 dark:text-surface-950"></i>
                </div>
              }
              <!-- check mark read indicator -->
              @if (isReadByAll()) {
                <div
                  class="inline-flex flex-row items-center justify-center bg-surface-600 dark:bg-surface-100 rounded-full w-5 h-5 border border-solid border-surface-0 dark:border-surface-950 [animation:checkmarksAnimation_1s_1] -ml-2"
                  [pTooltip]="'cl_chat.read' | translate"
                  tooltipPosition="left"
                  container="body"
                >
                  <i class="mi2-check text-[8px] text-surface-0 dark:text-surface-950"></i>
                </div>
              }
            </div>
          }
        </div>

        @if (showEditMode()) {
          <div class="edit-area">
            @if (!config() || !config().hideMentions) {
              <span id="mentionsDropup" #mentionsAnchor></span>
              <p-menu
                #mentionsDropdown
                [model]="textAreaProps().mentions"
                [popup]="true"
                (onShow)="restoreTextAreaFocus()"
                appendTo="body"
                styleClass="mentions-dropdown"
                [ngClass]="{ 'mobile-dropdown': isMobile }"
              >
                <ng-template pTemplate="item" let-item>
                  <div
                    class="mentions-item"
                    #dropdownMentions
                    [ngClass]="{
                      'mentions-mobile-item': isMobile,
                      isSelected: !isMobile && item.styleClass && item.styleClass.includes('selected-mention')
                    }"
                    (click)="enterMention(item)"
                  >
                    @if (item.userId !== 'here') {
                      <mi-avatar
                        [hash]="item.userId | hash"
                        [name]="item.displayName"
                        [initials]="item.displayName | initials"
                        [photoUrl]="item.avatars && item.avatars[50] ? item.avatars[50] : ''"
                      ></mi-avatar>
                    }
                    @if (item.userId === 'here') {
                      <div class="flex items-center justify-center min-w-[35px] min-h-[35px]">
                        <i class="mi2-speaker-on text-lg"></i>
                      </div>
                    }
                    <div class="ellipsis-overflow">
                      @if (config()?.reverseMentionSearchNames) {
                        <span class="mention-name">
                          {{ item.displayName.split(' ').reverse().join(' ') }}
                        </span>
                      } @else {
                        <span class="mention-name">
                          {{ item.displayName }}
                        </span>
                      }
                      <span class="mention-email">
                        {{ item.email }}
                      </span>
                    </div>
                  </div>
                </ng-template>
              </p-menu>
            }
            <div class="text-area-container">
              <div
                class="text-area edit-text-area"
                id="text-area"
                #editTextArea
                [attr.contenteditable]="true"
                role="textbox"
                aria-multiline="true"
                [attr.aria-label]="'cl_chat.editMessage' | translate"
                [innerHTML]="isQuotedContentType() ? editQuotedBody() : item().clCompChat_displayBody"
                (paste)="onPaste($event)"
                (keyup)="onKeyUp($event)"
                (keypress)="onEditKeyPress($event)"
                (mouseup)="getCaretPosition()"
                (keydown.enter)="!isOffline() ? saveEditedMessage($event) : !$event.shiftKey && $event.preventDefault()"
              ></div>
              <div class="edit-text-area-buttons">
                <div class="emoji-button">
                  <button
                    #emojiButton
                    class="button-remove-style"
                    tabindex="0"
                    [attr.aria-label]="'cl_chat.sendEmoji' | translate"
                    (click)="openEmojiDropDown(true, emojiButton); detectChanges()"
                    (keydown.enter)="openEmojiDropDown(true, emojiButton); detectChanges()"
                  >
                    <i class="mi2-happy-face text-2xl"></i>
                  </button>

                  <p-popover
                    #emojisPopover
                    styleClass="[&_.p-popover-content]:p-0 [&::before]:hidden [&::after]:hidden"
                    [style]="{
                      width: editTextArea.offsetWidth < 400 ? editTextArea.offsetWidth / 14 + 'rem' : '25rem',
                      border: 'none',
                      'box-shadow': 'none',
                      background: 'transparent'
                    }"
                    [ngClass]="{
                      'emoji-dropdown-override': overrideEmojiDropdownPos()
                    }"
                    (onShow)="emojiDropdownVisible.set(true)"
                    (onHide)="emojiDropdownVisible.set(false); openEmojiDropDown(false)"
                  >
                    <emoji-picker
                      [enableTwemoji]="config()?.enableTwemoji"
                      (emojiOutput)="onEmojiClick($event)"
                    ></emoji-picker>
                  </p-popover>
                </div>
              </div>
            </div>
            <div class="edit-buttons-area">
              <button
                tabindex="0"
                class="chat-one-app-button chat-cancel-button modal-button"
                (click)="cancelEditMessage($event)"
                (keydown.enter)="cancelEditMessage($event)"
                [ngClass]="primeThemeService.isDarkMode() ? 'primary-dark' : 'primary-grey'"
                [ngStyle]="{ 'z-index': editMode() ? 2 : 1 }"
              >
                {{ 'cl_chat.cancel' | translate }}
              </button>
              <button
                tabindex="0"
                class="chat-one-app-button primary-blue chat-ok-button modal-button"
                [disabled]="isOffline() || !editTextArea?.innerText.trim()"
                (click)="!isOffline() ? saveEditedMessage($event) : ''"
                [ngStyle]="{ 'box-shadow': 'var(--p-mi-shadow)', 'z-index': editMode() ? 2 : 1 }"
              >
                <i class="mi2-save text-lg text-surface-0 mr-1"></i>
                {{ 'cl_chat.updateMessage' | translate }}
              </button>
            </div>
          </div>
        }
      </div>
      <!-- END MAIN CONTENT -->
      <!-- Reactions -->
      @if (!previewMode && reactions() && reactions()[item().messageId]) {
        @for (emoji of reactionEmojis; track emoji) {
          <ng-template #tipReaction>
            @for (reaction of reactions()[item().messageId][emoji]; track reaction.userId; let i = $index) {
              @if (i < 10) {
                <div>{{ getDisplayName(reaction.userId) }}</div>
              }
            }
            @if (reactions()[item().messageId][emoji].length > 10) {
              <div>
                <b>+{{ reactions()[item().messageId][emoji].length - 10 }}</b>
              </div>
            }
          </ng-template>
          @if (reactions()[item().messageId] && reactions()[item().messageId][emoji]) {
            <div
              [pTooltip]="tipReaction"
              tooltipPosition="top"
              container="body"
              [autoHide]="false"
              tooltipEvent="both"
              role="button"
              [attr.tabindex]="currentTabIndex()"
              [attr.aria-pressed]="!!myReactions()[emoji]"
              [attr.aria-label]="
                (getReactionNameKey(emoji) | translate) +
                ', ' +
                reactions()[item().messageId][emoji].length +
                ' ' +
                ('cl_chat.reactionOptions.count' | translate)
              "
              (keydown.enter)="!textAreaDisabled() ? setReaction(emoji) : ''"
              (click)="!textAreaDisabled() ? setReaction(emoji) : ''"
              class="reactions-view"
              [ngClass]="{
                'my-reaction': myReactions()[emoji],
                'text-area-disabled': textAreaDisabled(),
                'icon-edit-mode': showEditMode() && !isMobile
              }"
              (keydown.enter)="!textAreaDisabled() ? setReaction(emoji) : ''"
            >
              <div
                class="reaction-emoji"
                data-e2e="reactions-emoji"
                [innerHTML]="isMobile || !config()?.enableTwemoji ? emoji : (emoji.codePointAt(0).toString(16) | emoji)"
              ></div>
              <div class="reaction-count" aria-hidden="true">
                {{ reactions()[item().messageId][emoji].length }}
              </div>
            </div>
          }
        }
      }
    </div>
    <ng-template [ngTemplateOutlet]="avatarRead"> </ng-template>
    <!-- Read indicators -->
    @if (
      (!selectMessagesMode &&
        item().clCompChat_mostRecentSent &&
        (!item().clCompChat_readList || item().clCompChat_readList.length === 0 || noReadIndicators()) &&
        !(item().clCompChat_lastMessageToCheckForRead && item().clCompChat_readList?.length && !noReadIndicators()) &&
        !isSearch &&
        !isSnapshot) ||
      item().clCompChat_state === 'sending' ||
      item().clCompChat_state === 'failed' ||
      item().clCompChat_state === 'pending'
    ) {
      <div class="sending-indicator" [ngClass]="{ 'icon-edit-mode': showEditMode() && !isMobile }">
        @if (item().clCompChat_state === 'sending') {
          <span>{{ 'cl_chat.sending' | translate }}</span>
        }
        @if (item().clCompChat_state === 'sent') {
          <span>{{ 'cl_chat.delivered' | translate }}</span>
        }
        @if (item().clCompChat_state === 'pending') {
          <span>{{ 'cl_chat.pendingSend' | translate }}</span>
        }

        @if (item().clCompChat_state === 'failed') {
          <div class="fail-indicator" role="alert">
            <i class="mi2-error text-2xl text-red-500"></i>
            <span class="failed-send">{{ 'cl_chat.failedToSend' | translate }}</span>

            <button [attr.tabindex]="currentTabIndex()" class="click-to-retry" (click)="retrySend()">
              <span>{{ 'cl_chat.clickToRetry' | translate }}</span>
              <i class="mi2-redo text-lg ml-1"></i>
            </button>

            @if (item().clCompChat_state === 'failed' || item().clCompChat_state === 'pending') {
              <button [attr.tabindex]="currentTabIndex()" (click)="deletePendingSend()" class="pending-send-delete">
                {{ 'cl_chat.delete' | translate }}
              </button>
            }
          </div>
        }
      </div>
    }
    @if (isAttachmentError()) {
      <div class="reload-indicator">
        <div class="fail-indicator" role="alert">
          <i class="mi2-error text-2xl text-red-500"></i>
          <span class="failed-load">{{ 'cl_chat.failedToLoadAttachment' | translate }}</span>

          <button [attr.tabindex]="currentTabIndex()" class="click-to-retry" (click)="retryLoad()">
            <span>{{ 'cl_chat.clickToRetry' | translate }}</span>
            <i class="mi2-redo text-lg ml-1"></i>
          </button>
        </div>
      </div>
    }
    <!-- read-indicator -->
    <ng-template #avatarRead>
      @if (
        !noReadIndicators() &&
        item().clCompChat_lastMessageToCheckForRead &&
        item().clCompChat_readList &&
        item().clCompChat_readList.length &&
        !isSearch &&
        !isSnapshot &&
        !previewMode
      ) {
        <div
          class="read-indicator"
          [ngClass]="{ 'video-read-indicator': isVideoMessage(), 'icon-edit-mode': showEditMode() && !isMobile }"
          [ngStyle]="{
            'max-width': getChatMessageAvatarReadMaxWidth(),
            'margin-left': !isContinuation() ? 3.75 + 'rem' : 0.75 + 'rem'
          }"
        >
          @for (r of item().clCompChat_readList; track r; let i = $index) {
            <div>
              @if (i < 5) {
                <mi-avatar
                  [hash]="r | hash"
                  [name]="getDisplayName(r)"
                  [initials]="getDisplayName(r) | initials"
                  [photoUrl]="chatAdminService.avatars[r]?.hasOwnProperty('50') ? chatAdminService.avatars[r][50] : ''"
                  [tooltip]="getDisplayName(r)"
                  [ngClass]="item().clCompChat_readList.length === 1 ? 'ml-1.5' : '-ml-1.5'"
                  styleClass="!w-5 !h-5 !text-[8px]"
                  alt=""
                >
                </mi-avatar>
              }
            </div>
          }
          @if (item().clCompChat_readList.length > 5) {
            <div
              class="read-indicator-plus"
              tabindex="0"
              [pTooltip]="tipRead"
              tooltipPosition="top"
              container="body"
              [autoHide]="false"
              tooltipEvent="both"
            >
              +{{ item().clCompChat_readList.length - 5 }}
            </div>
          }
          <ng-template #tipRead>
            @for (r of item().clCompChat_readList; track r; let i = $index) {
              <div class="read-tooltip-name">
                @if (i >= 5 && i < 15) {
                  <div>{{ getDisplayName(r) }}</div>
                }
              </div>
            }
            @if (item().clCompChat_readList.length > 15) {
              <div class="read-tooltip-name">
                <b>+{{ item().clCompChat_readList.length - 15 }}</b>
              </div>
            }
          </ng-template>
        </div>
      }
    </ng-template>
  </div>
}
